import { render, staticRenderFns } from "./ModalInactivateResponse.vue?vue&type=template&id=1bcf9c16"
import script from "./ModalInactivateResponse.vue?vue&type=script&lang=js"
export * from "./ModalInactivateResponse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports